import React from 'react'
import LayoutContainer from './Layout/LayoutContainer'
import ResizeListenerContainer from './ResizeListener/ResizeListenerContainer'
import LegalDialogContainer from './LegalDialog/LegalDialogContainer'
import LmThemeProvider from './LmThemeProvider'

export default () => {
	return (
		<LmThemeProvider>
			<ResizeListenerContainer />
			<LegalDialogContainer />
			<LayoutContainer />
		</LmThemeProvider>
)}



// WEBPACK FOOTER //
// ./src/components/App.js